/**
 * Taxes Service
 * Handles all tax-related API calls
 */

import network from '../../Network/NetworkManager';

const APPURL = require('../../Constants/URLConstants');

/**
 * Get taxes with optional filters
 * @param {object} params - Query parameters
 * @returns {Promise<object>} - Response with taxes array
 */
export const getTaxes = async (params = {}) => {
  try {
    const queryParams = {
      per_page: params.per_page || '100',
      type: params.type || 'tax',
    };

    // Add optional params
    if (params.page) {
      queryParams.page = params.page.toString();
    }
    if (params.active !== undefined) {
      queryParams.active = params.active.toString();
    }

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await network.networkCall(
      `${APPURL.URLPaths.taxes}?${queryString}`,
      'GET',
      '',
      '',
      '',
    );

    if (response.status && response.data?.taxes) {
      return response.data.taxes;
    }

    return response.taxes || [];
  } catch (error) {
    console.error('Error fetching taxes:', error);
    throw error;
  }
};

/**
 * Get tax by ID
 * @param {number} taxId - Tax ID
 * @returns {Promise<object>} - Response with tax details
 */
export const getTaxById = async (taxId) => {
  try {
    const response = await network.networkCall(
      `${APPURL.URLPaths.taxes}/${taxId}`,
      'GET',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error fetching tax:', error);
    throw error;
  }
};
